import type { ReactNode } from 'react'
import { LoadingButton } from './LoadingButton'
import { IconCheck, IconX } from './Icon'

type ConfirmDialogVariant = 'approve' | 'reject'

type ConfirmDialogProps = {
  variant: ConfirmDialogVariant
  title: string
  message: ReactNode
  confirmLabel: string
  busy?: boolean
  error?: string | null
  onCancel: () => void
  onConfirm: () => void
}

export function ConfirmDialog({
  variant,
  title,
  message,
  confirmLabel,
  busy = false,
  error,
  onCancel,
  onConfirm,
}: ConfirmDialogProps) {
  return (
    <div className="dialog-backdrop" onClick={onCancel}>
      <div
        className="dialog card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="confirm-dialog-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="confirm-dialog">
          <span className={`confirm-dialog-icon confirm-dialog-icon--${variant}`} aria-hidden="true">
            {variant === 'approve' ? <IconCheck /> : <IconX />}
          </span>
          <div className="confirm-dialog-body">
            <h2 id="confirm-dialog-title">{title}</h2>
            <p>{message}</p>
          </div>
        </div>

        {error && <p className="form-error">{error}</p>}

        <div className="confirm-dialog-actions">
          <button type="button" className="btn btn-ghost" disabled={busy} onClick={onCancel}>
            キャンセル
          </button>
          <LoadingButton
            variant={variant === 'reject' ? 'ghost' : 'primary'}
            isLoading={busy}
            loadingLabel={`${confirmLabel}中…`}
            onClick={onConfirm}
          >
            {confirmLabel}
          </LoadingButton>
        </div>
      </div>
    </div>
  )
}
